export enum PGDASDTipoDASEnum {

  COBRANCA,
  DAS,
  SENDA
}
